var _polygon, _polygon2, _polygon3, _polygon4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.46px",
    height: "105px",
    viewBox: "0 0 283.46 105",
    enableBackground: "new 0 0 283.46 105",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#14709C",
    points: "261.366,23.139 261.366,50.015 246.471,35.632 246.471,8.757 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FED448",
    points: "261.366,23.139 261.366,50.015 237.061,36.969 237.061,10.094 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7941E",
    points: "261.366,23.139 261.366,50.015 228.212,42.23 228.212,15.354 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#14709C",
    points: "261.366,23.139 261.366,50.015 234.177,52.121 227.66,58.204 227.698,52.623 222.044,53.061  222.044,26.185 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -73.46,
    width: 283.46,
    height: 283.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M51.808,58.513c7.411,0,13.262,3.399,13.262,11.145 c0,3.287-1.727,6.241-5.405,7.746c4.681,1.394,6.631,6.019,6.631,8.973c0,8.525-6.798,11.145-14.488,11.145H33.919V58.513H51.808z  M40.105,74.673h11.759c4.68,0,7.02-1.839,7.02-4.904c0-2.73-2.395-5.627-7.076-5.627H40.105V74.673z M40.105,91.726h11.703 c3.454,0,8.247-1.115,8.247-5.406c0-4.179-4.625-6.072-8.191-6.072H40.105V91.726z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M77.279,61.967c0,4.737-7.133,4.737-7.133,0 C70.146,57.287,77.279,57.287,77.279,61.967 M70.814,97.521h5.74V69.938h-5.74V97.521z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M104.066,70.048h5.572v27.473h-5.461l-0.278-4.458 c-1.839,3.511-6.074,5.183-9.474,5.183c-8.024,0.056-14.097-5.127-14.097-14.488c0-9.196,6.297-14.323,14.209-14.323 c3.901,0,7.634,1.84,9.362,4.96L104.066,70.048z M86.067,83.757c0,5.684,4.012,9.139,8.916,9.139c11.869,0,11.869-18.223,0-18.223 C90.079,74.673,86.067,78.128,86.067,83.757"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M133.867,97.521V82.419c0-4.068-2.34-7.468-6.408-7.468 s-6.631,3.399-6.631,7.468v15.102h-5.74V69.991h5.349l0.391,3.679c1.56-3.01,4.792-4.123,7.689-4.123 c3.511,0,7.078,1.447,8.638,5.516c2.23-4.068,5.685-5.46,9.417-5.46c7.578,0,11.647,4.792,11.647,12.705v15.213h-5.796V82.308 c0-4.068-2.006-7.3-6.075-7.3c-4.067,0-6.686,3.343-6.686,7.411v15.102H133.867z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M168.621,70.048V84.76c0,4.681,2.676,7.913,7.469,7.913 c4.513,0,7.634-3.734,7.634-8.304V70.048h5.74v27.528h-5.184l-0.334-4.067c-2.676,3.064-5.629,4.457-9.473,4.457 c-6.744,0-11.591-4.848-11.591-13.15V70.048H168.621z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M203.354,62.134v7.969h8.024v4.96h-8.08v13.096 c0,2.897,1.283,4.514,3.957,4.514c1.115,0,2.396-0.391,3.511-0.947l1.671,4.903c-1.895,0.836-3.565,1.226-5.517,1.226 c-5.962,0.168-9.361-3.231-9.361-9.695V75.063h-5.294v-4.96h5.294v-7.356L203.354,62.134z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14709C",
    d: "M236.17,70.048h5.572v27.473h-5.461l-0.278-4.458 c-1.839,3.511-6.073,5.183-9.474,5.183c-8.024,0.056-14.098-5.127-14.098-14.488c0-9.196,6.298-14.323,14.21-14.323 c3.9,0,7.634,1.84,9.361,4.96L236.17,70.048z M218.171,83.757c0,5.684,4.013,9.139,8.916,9.139c11.869,0,11.869-18.223,0-18.223 C222.184,74.673,218.171,78.128,218.171,83.757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.1ead311ec452fd2930595577242d4b43.svg";
export { ForwardRef as ReactComponent };